import React from "react";
// import loader from "../../assets/images/loader.webm";
import styled from "styled-components";
import breakpoints from "../../constants/breakpoints";
const Styles = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 90vh;
  width: 100%;
  img {
    height: 40px;
    width: 40px;
  }
  @media (max-width: ${breakpoints.sm}) {
    video {
      height: 40px;
      width: 40px;
    }
  }
`;
const MainLoader = () => {
  return (
    <Styles>
      <video autoPlay loop muted style={{ width: "2%", height: "auto" }}>
        {/* <source src={loader} type="video/webm" /> */}
      </video>
    </Styles>
  );
};

export default MainLoader;
